var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","bottom":"calc(100% - 18px)","left":"32px"}},[(_vm.showNameplate)?_c('div',{staticClass:"nameplate",style:(_vm.nameplateStyle)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.nameplateText)}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e3e384c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/ui/Nameplate.vue
// module id = null
// module chunks = 